<p-table
  id="users-monitoring-table"
  [value]="usersData"
  [scrollable]="true"
  scrollHeight="max(600px, calc(100vh - 520px))"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template #header>
    <tr class="sticky top-0 z-20 bg-white">
      <th
        apeResponsiveFrozen
        style="min-width: 52px;"
        class="sticky top-0 z-20 bg-white"
      >
        <div class="flex items-center justify-center">
          <input
            class="w-5 h-5 cursor-pointer accent-black !p-4"
            type="checkbox"
            [checked]="allUsersChecked"
            (change)="allUsersCheckedChange()"
          />
        </div>
      </th>
      <th
        class="sticky top-0 z-20 bg-white !p-4"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <span class="font-bold text-black">
          {{ TRANSLATION_KEYS.admin.monitoring.details.table.NOMINATIVE | translate }}
        </span>
      </th>
      <!-- Feedback 360: colonna non prevista dal modulo Valutazione (spec 7.0) -->
      <th
        *ngIf="showFeedback360Columns"
        class="sticky top-0 z-20 bg-white !p-4 [text-align-last:right] pr-[12px]! text-end!"
      >
        <span class="font-bold text-black">
          {{ TRANSLATION_KEYS.generic.phases.feedback360Phase | translate }}
        </span>
      </th>
      <th
        *ngIf="showFeedback360Columns"
        class="sticky top-0 z-20 bg-white !p-4 pl-[6px]!"
      >
        <svg-icon
          src="assets/icons/clipboard-check.svg"
          class="w-[20px] h-[20px]"
          [applyClass]="true"
          [svgAriaLabel]="'generic.accessibility.INFO_ICON_LABEL' | translate"
        />
      </th>
      <th class="!p-4 sticky top-0 z-20 bg-white">
        <span class="font-bold text-black">
          {{ TRANSLATION_KEYS.generic.phases.selfEvaluationPhase | translate }}
        </span>
      </th>
      <th class="!p-4 sticky top-0 z-20 bg-white">
        <span class="font-bold text-black">
          {{ TRANSLATION_KEYS.generic.phases.evaluationPhase | translate }}
        </span>
      </th>
      <th class="!p-4 sticky top-0 z-20 bg-white">
        <span class="font-bold text-black">
          {{ TRANSLATION_KEYS.admin.monitoring.participants.DELIVERY | translate }}
        </span>
      </th>
      <th
        pFrozenColumn
        alignFrozen="right"
        class="text-center p-4 font-bold text-[var(--colors-gray-scale-black)] sticky top-0 z-30 bg-white"
      >{{ TRANSLATION_KEYS.admin.ACTION | translate }}</th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-user
  >
    <tr>
      <td
        class="!px-4 !py-3.5"
        apeResponsiveFrozen
        style="min-width: 52px;"
      >
        <div class="flex items-center justify-center">
          <input
            class="w-5 h-5 cursor-pointer accent-black"
            type="checkbox"
            [checked]="user.checked"
            (change)="user.checked = !user.checked; userCheckedChange(user)"
          />
        </div>
      </td>
      <td
        class="!px-4 !py-3.5"
        apeResponsiveFrozen
        style="min-width: 150px;"
      >
        <div class="flex flex-row items-center gap-[10px]">
          <ape-avatar
            [image]="user.avatarImage"
            [forename]="user.forename"
            [surname]="user.surname"
            size="medium"
            shape="square"
            [attr.aria-hidden]="true"
            [withRing]="false"
            [variant]="'simple'"
          /><span class="font-normal text-[#000]">
            {{ user.surname + " " + user.forename }}
          </span>
        </div>
      </td>
      <td
        *ngIf="showFeedback360Columns"
        class="!px-4 !py-3.5 !text-end"
      >
        <div class="flex flex-row justify-end">
          <div
            class="mr-[10px] rounded-[20px] h-[26px] border-2 border-[#EC119C] bg-[#EC119C] px-[10px] py-0"
            *ngIf="user.feedback360ToApproveCount"
            [pTooltip]="tooltipContent"
            tooltipPosition="top"
            tooltipEvent="hover"
            tooltipStyleClass="custom-tooltip-monitoring-users-table"
          >
            <p class="text-white text-xs font-bold leading-5">{{user.feedback360ToApproveCount}}</p>
          </div>
          <ng-template #tooltipContent>
            <p class="text-[#F1F5F9]! text-[14px]! leading-[20px]! font-normal">{{
              TRANSLATION_KEYS.admin.monitoring.TO_BE_APPROVED | translate | translate }}</p>
          </ng-template>
          <ape-status-badge
            *ngIf="user.feedback360Status && user.feedback360Status !== 'NOT_AVAILABLE'
        && user.feedback360Status === 'NOT_DONE'"
            [aspect]="'fill'"
            [kind]="getStatusKind(user.feedback360Status)"
            [label]="('admin.monitoring.details.table.status.' + user.feedback360Status) | translate"
          />
          <p
            class="text-base font-bold text-[var(--colors-gray-scale-black)]"
            *ngIf="user.feedback360Status === 'NOT_AVAILABLE'"
          >N/A</p>
          <p
            class="text-base font-bold text-[var(--colors-gray-scale-black)]"
            *ngIf="withFeedback360Counters(user)"
          >
            {{user.completedFeedback360Count}}/{{user.requestedFeedback360Count}}
          </p>
          <ape-status-badge
            *ngIf="hasPendingFeedback360(user)"
            [aspect]="'fill'"
            [kind]="'in-progress'"
            [label]="'generic.PENDING' | translate"
          />
          <ape-status-badge
            *ngIf="hasListToValidateFeedback360(user)"
            [aspect]="'fill'"
            [kind]="'blocked'"
            [label]="('admin.monitoring.LIST_TO_VALIDATE') | translate"
          />
        </div>
      </td>
      <td
        *ngIf="showFeedback360Columns"
        class="!px-4 !py-3.5 !pl-0"
      >
        <div
          role="button"
          [attr.tabindex]="(!user.hasManagerSubmittedFeedback360ToAdminApproval || user.scorecardType !== 'PROFESSIONAL_2026') ? 0 : -1"
          (click)="(user.hasManagerSubmittedFeedback360ToAdminApproval && user.scorecardType === 'PROFESSIONAL_2026') ? goToHandleListFeedback360(user) : null"
          (keydown.enter)="(user.hasManagerSubmittedFeedback360ToAdminApproval && user.scorecardType === 'PROFESSIONAL_2026') ? goToHandleListFeedback360(user) : null"
          (keydown.space)="(user.hasManagerSubmittedFeedback360ToAdminApproval && user.scorecardType === 'PROFESSIONAL_2026') ? goToHandleListFeedback360(user) : null"
          class="bg-white cursor-pointer flex items-center justify-center h-[32px] w-[32px] border-2 border-[#002058] rounded-[10px]"
          [ngClass]="{
            'bg-black!': user.hasFeedback360ToBeValidated || user.feedback360ToApproveCount,
            'cursor-default!': !(user.hasManagerSubmittedFeedback360ToAdminApproval && user.scorecardType === 'PROFESSIONAL_2026') || !user.canImpersonateUser
          }"
          [pTooltip]="tooltipContentOnHandleListButton"
          tooltipPosition="top"
          tooltipEvent="hover"
          tooltipStyleClass="custom-tooltip-monitoring-users-table"
        >
          <svg-icon
            src="assets/icons/clipboard-check.svg"
            class="w-[20px] h-[20px]"
            [applyClass]="true"
            [svgClass]="(user.hasFeedback360ToBeValidated || user.feedback360ToApproveCount) ? 'stroke-white' : 'stroke-black'"
            [svgAriaLabel]="'generic.accessibility.INFO_ICON_LABEL' | translate"
          />
        </div>
        <ng-template #tooltipContentOnHandleListButton>
          <p class="text-[#F1F5F9]! text-[14px]! leading-[20px]! font-normal">{{
            TRANSLATION_KEYS.admin.monitoring.ON_HANDLE_LIST_FEEDBACK360 | translate }}</p>
        </ng-template>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.selfAssessmentStatus && user.selfAssessmentStatus !== 'NOT_AVAILABLE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.selfAssessmentStatus)"
          [label]="('admin.monitoring.details.table.status.' + user.selfAssessmentStatus) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.selfAssessmentStatus === 'NOT_AVAILABLE'"
        >N/A</p>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.evaluationStatus && user.evaluationStatus !== 'NOT_AVAILABLE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.evaluationStatus)"
          [label]="('admin.monitoring.details.table.status.' + user.evaluationStatus) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.evaluationStatus === 'NOT_AVAILABLE'"
        >N/A</p>
      </td>
      <td class="!px-4 !py-3.5">
        <ape-status-badge
          *ngIf="user.deliveryStatus && user.deliveryStatus !== 'NOT_AVAILABLE'"
          [aspect]="'fill'"
          [kind]="getStatusKind(user.deliveryStatus)"
          [label]="('admin.monitoring.details.table.status.' + user.deliveryStatus) | translate"
        />
        <p
          class="text-base font-bold text-[var(--colors-gray-scale-black)]"
          *ngIf="user.deliveryStatus === 'NOT_AVAILABLE'"
        >N/A</p>
      </td>
      <td
        pFrozenColumn
        alignFrozen="right"
        class="relative !text-center"
      >
        <ape-button
          style="position: relative;"
          [id]="'action-user-button-' + user.userId"
          class="my-0 mx-auto !w-8 !h-8"
          [cssClass]="'!w-8 !h-8'"
          size="small"
          aspect="icon"
          variant="primary"
          [rightIcon]="'assets/icons/ellipsis.svg'"
          [ariaLabel]="TRANSLATION_KEYS.admin.processSetup.table.ACCESS_PROCESS | translate"
          (buttonClick)="toggleActionColumn(user, $event)"
        />
      </td>
    </tr>
  </ng-template>
</p-table>

<ape-menu
  #apeMenu
  [menuItems]="menuItems"
/>